<table class="five-jobs">
  <caption class="five-jobs__caption">
    {{
      caption()
    }}
  </caption>
  <thead>
    <tr>
      <th scope="col">Job</th>
      <th scope="col">What does it here</th>
    </tr>
  </thead>
  <tbody>
    @for (row of rows(); track row.job) {
      <tr>
        <th scope="row">{{ label(row.job) }}</th>
        <td>{{ row.how }}</td>
      </tr>
    }
  </tbody>
</table>
